<template>
<div class="pb-5 px-md-3">
  <!--Title/Actions-->
  <div class="page-header">
    <div class="container d-flex justify-content-between p-0">
      <h3><i class="fas fa-city"></i>&nbsp;&nbsp;Property Group: {{editPropertyGroup.name}}</h3>
      <div>
        <b-button variant="primary" @click="doSavePropertyGroup()">Save</b-button>
      </div>
    </div>
  </div>
  <div v-if="editPropertyGroup" class="container form-container p-3 p-md-4">
    <b-form>
      <b-form-group>
        <label for="form-propertyGroup-name" class="control-label">Property Group Title</label>
        <b-input id="form-propertyGroup-name" placeholder="Property Group Name" v-model="editPropertyGroup.name"></b-input>
      </b-form-group>
      <label class="section-label mt-3"><i class="fas fa-building"></i> Properties</label>
      <b-form-group class="row align-items-center no-gutters rg-table-add w-100">
        <b-input-group prepend="Select" class="w-100">
          <b-form-select :options="propertiesOptions" v-model="selectedProperty"></b-form-select>
          <b-input-group-append>
            <b-button variant="success" @click="addPropertyToList">Add Property</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <!--Property List-->
      <b-table-simple bordered class="rg-table mt-md-0 mt-3 mb-0">
        <b-thead head-variant="dark">
          <b-tr>
            <b-th>
                Name
            </b-th>
            <b-th>
                Location
            </b-th>
            <b-th>
                Action
            </b-th>
          </b-tr>
        </b-thead>
          <b-tbody v-if="companyProperties.length > 0">
          <b-tr v-for="property in propertyGroupProperties" v-bind:key="property.id">
            <b-td>{{property.name}}</b-td>
            <b-td>{{ property.address.city }} {{ property.address.state }}</b-td>
            <b-td class="table-action text-center"><b-btn @click="deletePropertyAssociation(property.id)" variant="link"><i class="fas fa-trash"></i></b-btn></b-td>
          </b-tr>
          </b-tbody>
      </b-table-simple>
    </b-form>
  </div>
</div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'PropertyGroupEditor',
  created () {
    this.doLoadPropertyGroup()
    this.doLoadProperties()
  },
  components: {
  },
  data () {
    return {
      editPropertyGroup: {name: 'New Group', propertyAssociations: []},
      companyProperties: [],
      selectedProperty: {}
    }
  },
  computed: {
    propertyGroupId () {
      return this.$route.params.id === 'new' ? null : this.$route.params.id
    },
    propertiesOptions () {
      var properties = this.companyProperties
      var results = []
      results = properties.map((p) => { return { text: p.name, value: p.id } })
      console.log('Returning Property Options: ' + JSON.stringify(results, null, 2))
      return results
    },
    propertyGroupProperties () {
      var properties = []
      console.log('Edit Group: ' + JSON.stringify(this.editPropertyGroup, null, 2))
      for (var i = 0; i < this.editPropertyGroup.propertyAssociations.length; i++) {
        var prop = this.lookupProperty(this.editPropertyGroup.propertyAssociations[i])
        if (prop !== undefined) {
          properties.push(prop)
        }
      }
      return properties
    }
  },
  methods: {
    ...mapActions('company', ['createPropertyGroup', 'savePropertyGroup', 'getProperties', 'getPropertyGroup']),
    doLoadProperties () {
      return this.getProperties().then(r => {
        this.companyProperties = r.data.properties
      })
    },
    doSavePropertyGroup () {
      const forSave = Object.assign({}, this.editPropertyGroup)
      forSave.propertyAssociations = this.editPropertyGroup.propertyAssociations.map(a => a)
      console.log('Saving Group: ' + JSON.stringify(forSave, null, 2))
      var action = this.savePropertyGroup
      if (!this.propertyGroupId) {
        action = this.createPropertyGroup
      }
      action(forSave).then(() => this.$router.push({name: 'PropertyGroups'}))
    },
    async doLoadPropertyGroup () {
      if (this.propertyGroupId) {
        await this.getPropertyGroup(this.propertyGroupId).then(r => { this.editPropertyGroup = r.data.propertyGroup })
      }
    },
    addPropertyToList () {
      if (this.editPropertyGroup.propertyAssociations.find(p => p === this.selectedProperty) != null) {
        return
      }
      this.editPropertyGroup.propertyAssociations.push(this.selectedProperty)
    },
    deletePropertyAssociation (id) {
      console.log('deleting property association: ' + id)
      this.editPropertyGroup.propertyAssociations = this.editPropertyGroup.propertyAssociations.filter((p, i, arr) => p !== id)
      this.editPropertyGroup.propertyAssociations = this.editPropertyGroup.propertyAssociations.filter((p, i, arr) => p !== null)
    },
    lookupProperty (id) {
      return this.companyProperties.find(p => p.id === id)
    }

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/setup/PropertyGroup.vue